<template>
  <div class="body">
    <header>
      <div class="logofill">
        <a href="http://onthatass.com" :aria-label="$t('Accessibilty.AriaLabels.GoToHomepage')">
          <svg class="logo" viewBox="0 0 286 31" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M52.9673 20.4615L34.7828 3H29.7144V30.1538H34.8989V12.2692L53.6251 30.1538H58.1518V3H52.9673V20.4615Z" fill="white" />
            <path d="M78.735 30.1538H84.4999V7.96154H95.0237V3H68.2112V7.96154H78.735V30.1538Z" fill="white" />
            <path d="M102.143 18.3846H118.161V30.1538H123.926V3H118.161V13.4231H102.143V3H96.4167V30.1538H102.143V18.3846Z" fill="white" />
            <path d="M134.836 23.3846H147.836L151.705 30.1538H157.47L143.812 3H139.44L126.363 30.1538H131.702L134.836 23.3846ZM141.181 10.8846L146.289 19.6154H136.306L141.181 10.8846Z" fill="white" />
            <path d="M166.756 30.1538H172.482V7.96154H183.045V3H156.194V7.96154H166.756V30.1538Z" fill="white" />
            <path d="M203.628 3L190.551 30.1538H195.929L199.062 23.3846H212.062L215.931 30.1538H221.696L208.039 3H203.628V3ZM200.494 19.5769L205.369 10.8462L210.476 19.5769H200.494Z" fill="white" />
            <path d="M244.988 15.4615C243.285 14.4231 240.771 13.7692 237.443 13.5385L233.574 13.2308C231.137 13.0385 229.434 12.7692 228.506 12.4615C227.577 12.1538 227.074 11.5769 227.074 10.7692C227.074 9.57692 228.041 8.65385 229.937 8.03846C231.214 7.57692 232.646 7.34615 234.271 7.34615C236.166 7.34615 238.024 7.61538 239.881 8.15385C241.738 8.69231 243.324 9.5 244.64 10.5385L247.077 6.46154C244.33 4.76923 241.97 3.69231 239.997 3.15384C237.985 2.65384 236.089 2.38461 234.232 2.38461C230.866 2.38461 228.041 3.07692 225.759 4.5C223.321 6.07692 222.083 8.34615 222.083 11.3462C222.083 12.6538 222.354 13.8846 222.896 15C223.437 16.1154 224.211 17 225.178 17.6538C225.952 18.1538 226.881 18.5 227.925 18.7692C228.97 19.0385 230.556 19.2308 232.646 19.3846L236.437 19.7308C238.527 19.8846 239.958 20.1154 240.771 20.3462C242.086 20.7308 242.783 21.4231 242.783 22.4231C242.783 23.6538 241.854 24.5385 239.997 25.0769C238.565 25.5385 236.979 25.7692 235.199 25.7692C233.226 25.7692 231.214 25.5385 229.202 25C227.19 24.5 225.527 23.8462 224.172 23.0769L222.431 27.1539C226.765 29.5769 231.021 30.7308 235.238 30.6539C239.223 30.6539 242.396 29.8846 244.756 28.3846C247.116 26.7692 248.315 24.5769 248.315 21.8462C248.315 20.3462 247.928 18.9615 247.155 17.7308C246.652 16.8462 245.878 16.0385 244.988 15.4615Z" fill="white" />
            <path d="M271.955 15.4615C270.253 14.4231 267.738 13.7692 264.411 13.5385L260.542 13.2308C258.104 13.0385 256.402 12.7692 255.473 12.4615C254.545 12.1538 254.042 11.5769 254.042 10.7692C254.042 9.57692 255.009 8.65385 256.905 8.03846C258.182 7.57692 259.613 7.34615 261.238 7.34615C263.134 7.34615 264.991 7.61538 266.848 8.15385C268.705 8.69231 270.292 9.5 271.607 10.5385L274.045 6.46154C271.298 4.76923 268.938 3.69231 266.964 3.15384C264.952 2.65384 263.057 2.38461 261.199 2.38461C257.833 2.38461 255.009 3.07692 252.726 4.5C250.289 6.07692 249.051 8.34615 249.051 11.3462C249.051 12.6538 249.322 13.8846 249.863 15C250.405 16.1154 251.179 17 252.146 17.6538C252.92 18.1538 253.848 18.5 254.893 18.7692C255.938 19.0385 257.524 19.2308 259.613 19.3846L263.405 19.7308C265.494 19.8846 266.926 20.1154 267.738 20.3462C269.054 20.7308 269.75 21.4231 269.75 22.4231C269.75 23.6538 268.821 24.5385 266.964 25.0769C265.533 25.5385 263.946 25.7692 262.167 25.7692C260.194 25.7692 258.182 25.5385 256.17 25C254.158 24.5 252.494 23.8462 251.14 23.0769L249.399 27.1539C253.732 29.5769 257.988 30.7308 262.205 30.6539C266.191 30.6539 269.363 29.8846 271.723 28.3846C274.083 26.7692 275.283 24.5769 275.283 21.8462C275.283 20.3462 274.896 18.9615 274.122 17.7308C273.619 16.8462 272.884 16.0385 271.955 15.4615Z" fill="white" />
            <path d="M282.247 0C280.196 0 278.494 1.65384 278.494 3.73077C278.494 5.76923 280.158 7.46153 282.247 7.46153C284.298 7.46153 286 5.80769 286 3.73077C286 1.65384 284.298 0 282.247 0ZM282.247 6.65384C280.622 6.65384 279.268 5.34615 279.268 3.69231C279.268 2.07692 280.583 0.730769 282.247 0.730769C283.872 0.730769 285.226 2.03846 285.226 3.69231C285.226 5.34615 283.872 6.65384 282.247 6.65384Z" fill="white" />
            <path d="M283.214 4.34616C283.137 4.23077 282.982 4.11539 282.827 4C283.098 3.96154 283.33 3.8077 283.485 3.61539C283.64 3.42308 283.717 3.15385 283.717 2.84616C283.717 2.57693 283.679 2.38462 283.562 2.19231C283.446 2.00001 283.33 1.88462 283.176 1.8077C283.021 1.73078 282.75 1.69231 282.363 1.69231H280.893V5.84615H281.589V4.11539H281.744C281.899 4.11539 282.015 4.11539 282.092 4.15385C282.17 4.19231 282.247 4.23077 282.286 4.30769C282.363 4.38462 282.479 4.57693 282.673 4.92308L283.176 5.84615H283.988L283.562 5.03846C283.446 4.69231 283.33 4.46154 283.214 4.34616ZM282.17 3.42308H281.667V2.38462H282.208C282.518 2.38462 282.711 2.38462 282.789 2.42308C282.866 2.46154 282.943 2.50001 283.021 2.57693C283.059 2.65385 283.098 2.76924 283.098 2.88462C283.098 3.03847 283.059 3.11539 283.021 3.23077C282.982 3.3077 282.905 3.38462 282.827 3.38462C282.673 3.42308 282.479 3.42308 282.17 3.42308Z" fill="white" />
            <path d="M14.1994 2.73078C6.34524 2.73078 0 9.07693 0 16.8462C0 24.6538 6.34524 31 14.1994 31C22.0536 31 28.3988 24.6923 28.3988 16.8846C28.3988 9.07693 22.0536 2.73078 14.1994 2.73078ZM20.0804 27.5H16.0952L14.1607 24.1923L12.2262 27.5H8.24107L12.1488 22.3077L8.24107 17.1154H12.2262L14.1607 20.1154L16.0952 17.1154H20.0804L16.1726 22.3077L20.0804 27.5ZM20.1964 16.5769H16.2113L14.2768 13.2692L12.3423 16.5769H8.39583L12.3036 11.3846L8.39583 6.15386H12.3809L14.3155 9.15386L16.25 6.15386H20.2351L16.3274 11.3462L20.1964 16.5769Z" fill="white" />
          </svg>
        </a>
      </div>

      <a href="javascript:void(0);" aria-disabled="true">
        <svg class="basket" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="30" cy="30" r="30" fill="#456B8A" />
          <path d="M40.4287 22.9392C40.1848 22.6329 39.8736 22.3845 39.5182 22.2125C39.1628 22.0405 38.7724 21.9494 38.3761 21.946H21.7078L21.1879 19.9596C21.0468 19.4014 20.7195 18.9053 20.2581 18.5503C19.7968 18.1953 19.2277 18.0016 18.6412 18H15.8489C15.6241 18.001 15.4087 18.089 15.2498 18.245C15.0908 18.4009 15.001 18.6121 15 18.8326C15 19.289 15.3822 19.6651 15.8489 19.6651H18.6412C19.052 19.6651 19.4082 19.9329 19.5161 20.337L22.857 33.385C22.9981 33.9431 23.3251 34.439 23.7862 34.794C24.2473 35.149 24.8161 35.3428 25.4024 35.3447H36.3221C37.5272 35.3447 38.5958 34.5389 38.8701 33.385L40.9214 25.1143C41.0195 24.739 41.0259 24.3463 40.94 23.9681C40.8542 23.59 40.6786 23.237 40.4274 22.938L40.4287 22.9392ZM39.2536 24.7369L37.1996 33.0076C37.1507 33.199 37.0381 33.3689 36.8796 33.4903C36.7211 33.6118 36.5259 33.678 36.3247 33.6783H25.4024C25.201 33.6782 25.0054 33.6122 24.8467 33.4907C24.688 33.3692 24.5751 33.1992 24.5262 33.0076L22.1446 23.6379H38.3774C38.5153 23.6394 38.6512 23.6716 38.7746 23.7321C38.898 23.7926 39.0058 23.8799 39.0898 23.9873C39.1757 24.0908 39.2353 24.2129 39.2638 24.3434C39.2923 24.4739 39.2887 24.6092 39.2536 24.7382V24.7369ZM25.9783 36.4169C24.4183 36.4169 23.1313 37.6791 23.1313 39.2091C23.1313 40.7391 24.4183 42 25.9783 42C26.732 41.9966 27.454 41.7016 27.9871 41.1789C28.5202 40.6563 28.8214 39.9484 28.8252 39.2091C28.8252 37.6791 27.5382 36.4169 25.9783 36.4169ZM25.9783 40.3094C25.8303 40.3111 25.6834 40.2838 25.5464 40.229C25.4093 40.1743 25.2848 40.0932 25.1802 39.9906C25.0755 39.8879 24.9929 39.7658 24.937 39.6314C24.8812 39.497 24.8533 39.353 24.8551 39.2078C24.8551 38.5907 25.3491 38.1075 25.9783 38.1075C26.6074 38.1075 27.1001 38.5907 27.1001 39.2078C27.1001 39.7994 26.5801 40.3094 25.9783 40.3094ZM35.3939 36.4169C33.834 36.4169 32.547 37.6791 32.547 39.2091C32.547 40.7391 33.834 42 35.3939 42C36.9539 42 38.2409 40.7378 38.2409 39.2078C38.2136 37.6779 36.9539 36.4156 35.3939 36.4156V36.4169ZM35.3939 40.3094C35.246 40.3111 35.0991 40.2838 34.9621 40.229C34.825 40.1743 34.7005 40.0932 34.5959 39.9906C34.4912 39.8879 34.4085 39.7658 34.3527 39.6314C34.2969 39.497 34.269 39.353 34.2708 39.2078C34.2708 38.5907 34.7648 38.1075 35.3939 38.1075C36.0244 38.1075 36.5171 38.5907 36.5171 39.2078C36.5171 39.7994 35.9971 40.3094 35.3939 40.3094Z" fill="#E2E2E3" />
        </svg>
      </a>
    </header>
    <div class="top">
      <div class="productshot">
        <OImage
          alt="Product photo perfume"
          img-class="w-full"
          v-bind="getImagePaths('eauta-productshot', '.png')"
        />
        <svg class="coming-soon-circle" viewBox="0 0 757 757" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_3368_24708)">
            <path d="M378.29 756.58C587.214 756.58 756.58 587.214 756.58 378.29C756.58 169.366 587.214 0 378.29 0C169.366 0 0 169.366 0 378.29C0 587.214 169.366 756.58 378.29 756.58Z" fill="black" />
            <path d="M468.34 141.18L494.55 84L506.67 89.56L485.05 136.72L508.24 147.35L503.65 157.36L468.34 141.17V141.18Z" fill="white" stroke="#1D1D1B" stroke-miterlimit="10" />
            <path d="M510.76 162.56L545.08 109.85L556.26 117.13L521.94 169.84L510.76 162.56Z" fill="white" stroke="#1D1D1B" stroke-miterlimit="10" />
            <path d="M552.45 194.54L576.63 148.94L576.36 148.67C569.65 156.15 565.1 161.08 562.73 163.45L542.04 184.14L533.61 175.71L578.08 131.24L590.92 144.08L567.44 188.62L567.62 188.8L612.79 165.95L625.63 178.79L581.16 223.26L572.37 214.47L593.42 193.42C594.41 192.43 595.57 191.3 596.9 190.03C598.23 188.76 601.81 185.45 607.65 180.1L607.38 179.83L561.08 203.19L552.44 194.55L552.45 194.54Z" fill="white" stroke="#1D1D1B" stroke-miterlimit="10" />
            <path d="M587.05 234.96L639.76 200.65L647.04 211.83L594.33 246.14L587.05 234.96Z" fill="white" stroke="#1D1D1B" stroke-miterlimit="10" />
            <path d="M611.64 279.75L606.11 267.61L653.25 246.15L646.17 230.61L656.27 226.01L675.95 269.23L665.85 273.83L658.77 258.29L611.63 279.75H611.64Z" fill="white" stroke="#1D1D1B" stroke-miterlimit="10" />
            <path d="M628.94 337.24L620.37 302.05L681.48 287.16L690.05 322.35L679.43 324.94L674.01 302.7L660.59 305.97L665.63 326.66L655.01 329.25L649.97 308.56L634.21 312.4L639.63 334.64L628.93 337.25L628.94 337.24Z" fill="white" stroke="#1D1D1B" stroke-miterlimit="10" />
            <path d="M664.18 398.41C653.83 398.68 645.83 395.94 640.17 390.19C634.51 384.44 631.54 376 631.25 364.88L630.79 347.08L693.67 345.45L694.18 365.19C694.45 375.45 691.94 383.5 686.67 389.31C681.4 395.13 673.9 398.16 664.18 398.41ZM663.48 384.57C676.98 384.22 683.58 378.08 683.27 366.15L683.09 359.05L642.15 360.11L642.3 365.83C642.63 378.67 649.69 384.92 663.48 384.56V384.57Z" fill="white" stroke="#1D1D1B" stroke-miterlimit="10" />
            <path d="M617 465.35L626.73 430.46L687.31 447.36L677.58 482.25L667.05 479.31L673.2 457.26L659.9 453.55L654.18 474.06L643.66 471.12L649.38 450.61L633.76 446.25L627.61 468.29L617 465.33V465.35Z" fill="white" stroke="#1D1D1B" stroke-miterlimit="10" />
            <path d="M617.72 535.96C608.57 531.12 602.94 524.8 600.83 517.02C598.72 509.23 600.27 500.42 605.47 490.59L613.8 474.85L669.39 504.27L660.15 521.72C655.35 530.79 649.22 536.57 641.77 539.06C634.32 541.54 626.3 540.51 617.71 535.96H617.72ZM623.9 523.56C635.84 529.88 644.6 527.77 650.18 517.22L653.5 510.95L617.3 491.79L614.62 496.85C608.61 508.21 611.7 517.11 623.89 523.56H623.9Z" fill="white" stroke="#1D1D1B" stroke-miterlimit="10" />
            <path d="M582.2 528.72L631.79 567.41L623.59 577.92L574 539.23L582.2 528.72Z" fill="white" stroke="#1D1D1B" stroke-miterlimit="10" />
            <path d="M547.85 566.57L557.52 557.39L593.19 594.95L605.57 583.19L613.21 591.24L578.77 623.95L571.13 615.9L583.51 604.14L547.84 566.58L547.85 566.57Z" fill="white" stroke="#1D1D1B" stroke-miterlimit="10" />
            <path d="M528.89 582.07L564.97 633.59L554.05 641.24L517.97 589.72L528.89 582.07Z" fill="white" stroke="#1D1D1B" stroke-miterlimit="10" />
            <path d="M468.55 650.14C464.25 640.66 463.3 632.3 465.69 625.08C468.08 617.86 473.67 612.25 482.45 608.28C491.23 604.3 499.12 603.79 506.13 606.76C513.14 609.72 518.81 615.97 523.13 625.51C527.45 635.04 528.39 643.39 525.96 650.56C523.52 657.73 517.9 663.3 509.1 667.29C500.3 671.28 492.42 671.8 485.46 668.84C478.5 665.88 472.87 659.65 468.55 650.15V650.14ZM510.36 631.19C507.46 624.79 504.06 620.52 500.16 618.38C496.26 616.24 491.9 616.27 487.06 618.46C477.37 622.85 475.44 631.49 481.28 644.37C487.13 657.27 494.87 661.54 504.51 657.17C509.34 654.98 512.25 651.7 513.23 647.34C514.21 642.97 513.25 637.59 510.35 631.19H510.36Z" fill="white" stroke="#1D1D1B" stroke-miterlimit="10" />
            <path d="M391.45 632.72L408.18 630.03L442.76 672.65L443.14 672.59C441.27 664.38 440.04 658.51 439.47 654.97L434.76 625.75L446.52 623.86L456.52 685.96L439.91 688.63L405.45 646.46L405.15 646.51C406.87 654.51 408.01 660.18 408.54 663.52L413.27 692.91L401.42 694.82L391.42 632.72H391.45Z" fill="white" stroke="#1D1D1B" stroke-miterlimit="10" />
            <path d="M288.53 615.69L262.32 672.87L250.2 667.31L271.82 620.15L248.63 609.52L253.22 599.51L288.53 615.7V615.69Z" fill="#E2E2E3" />
            <path d="M246.12 594.31L211.8 647.02L200.62 639.74L234.94 587.03L246.12 594.31Z" fill="#E2E2E3" />
            <path d="M204.43 562.34L180.25 607.94L180.52 608.21C187.23 600.73 191.78 595.8 194.15 593.43L214.84 572.74L223.27 581.17L178.8 625.64L165.96 612.8L189.44 568.27L189.26 568.09L144.09 590.94L131.25 578.1L175.72 533.63L184.51 542.42L163.46 563.47C162.47 564.46 161.31 565.59 159.98 566.86C158.65 568.13 155.07 571.44 149.23 576.79L149.5 577.06L195.8 553.7L204.44 562.34H204.43Z" fill="#E2E2E3" />
            <path d="M169.83 521.91L117.12 556.22L109.84 545.04L162.55 510.73L169.83 521.91Z" fill="#E2E2E3" />
            <path d="M145.23 477.13L150.76 489.27L103.62 510.73L110.7 526.27L100.6 530.87L80.9199 487.65L91.0199 483.05L98.0999 498.59L145.24 477.13H145.23Z" fill="#E2E2E3" />
            <path d="M127.94 419.64L136.51 454.83L75.4 469.72L66.83 434.53L77.45 431.94L82.87 454.18L96.29 450.91L91.25 430.22L101.87 427.63L106.91 448.32L122.67 444.48L117.25 422.24L127.95 419.63L127.94 419.64Z" fill="#E2E2E3" />
            <path d="M92.7 358.47C103.05 358.2 111.05 360.94 116.71 366.69C122.37 372.44 125.34 380.88 125.63 392L126.09 409.8L63.21 411.43L62.7 391.69C62.43 381.43 64.94 373.39 70.21 367.57C75.48 361.75 82.98 358.72 92.7 358.47ZM93.4 372.31C79.9 372.66 73.3 378.8 73.61 390.73L73.79 397.83L114.73 396.77L114.58 391.05C114.25 378.21 107.19 371.96 93.4 372.32V372.31Z" fill="#E2E2E3" />
            <path d="M139.88 291.53L130.15 326.42L69.5699 309.52L79.2999 274.63L89.8299 277.57L83.6799 299.61L96.9799 303.32L102.7 282.81L113.23 285.75L107.51 306.26L123.13 310.62L129.28 288.57L139.89 291.53H139.88Z" fill="#E2E2E3" />
            <path d="M139.15 220.92C148.3 225.76 153.93 232.08 156.04 239.86C158.15 247.64 156.6 256.46 151.4 266.29L143.07 282.03L87.48 252.61L96.72 235.16C101.52 226.09 107.65 220.31 115.1 217.82C122.55 215.34 130.57 216.37 139.16 220.92H139.15ZM132.97 233.32C121.03 227 112.27 229.11 106.69 239.66L103.37 245.93L139.57 265.09L142.25 260.03C148.26 248.67 145.17 239.77 132.98 233.32H132.97Z" fill="#E2E2E3" />
            <path d="M174.68 228.16L125.09 189.47L133.29 178.96L182.88 217.65L174.68 228.17V228.16Z" fill="#E2E2E3" />
            <path d="M209.03 190.31L199.36 199.49L163.69 161.93L151.31 173.69L143.67 165.64L178.11 132.93L185.75 140.98L173.37 152.74L209.04 190.3L209.03 190.31Z" fill="#E2E2E3" />
            <path d="M227.99 174.81L191.91 123.29L202.83 115.64L238.91 167.16L227.99 174.81Z" fill="#E2E2E3" />
            <path d="M288.32 106.73C292.62 116.21 293.57 124.57 291.18 131.79C288.79 139.01 283.2 144.62 274.42 148.59C265.64 152.57 257.75 153.08 250.74 150.11C243.73 147.14 238.06 140.9 233.74 131.36C229.42 121.83 228.48 113.48 230.91 106.31C233.35 99.14 238.96 93.57 247.77 89.58C256.57 85.59 264.45 85.07 271.41 88.03C278.37 90.98 284.01 97.22 288.32 106.72V106.73ZM246.51 125.68C249.41 132.08 252.81 136.35 256.71 138.49C260.61 140.63 264.97 140.6 269.81 138.41C279.5 134.02 281.43 125.38 275.59 112.5C269.74 99.6 262 95.33 252.36 99.7C247.53 101.89 244.62 105.17 243.64 109.53C242.66 113.9 243.62 119.28 246.52 125.68H246.51Z" fill="#E2E2E3" />
            <path d="M365.43 124.16L348.7 126.86L314.12 84.24L313.74 84.3C315.61 92.51 316.84 98.38 317.41 101.92L322.12 131.14L310.36 133.03L300.36 70.93L316.97 68.26L351.43 110.42L351.73 110.37C350.01 102.37 348.87 96.7 348.34 93.36L343.61 63.97L355.46 62.06L365.46 124.16H365.43Z" fill="#E2E2E3" />
          </g>
          <defs>
            <clipPath id="clip0_3368_24708">
              <rect width="756.58" height="756.58" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div class="intro">
        <h1>Powerful scent of freshly picked cotton</h1>
        <p>EAU’TA is for the self-confident man, who wants to feel confident and likes to look fresh.</p>
        <p>In addition to aromatic accents such as rosemary, wood and green notes of grass or leaves, the perfume is characterized by the scent of freshly picked cotton. </p>
        <p><i>“A scent of fresh boxer shorts”</i></p>
        <div class="intro-buttons">
          <a class="a-button" href="javascript:void(0);" aria-disabled="true">Coming soon</a>
          <a
            href="#"
            class="a-line"
            @click.prevent="pageScroll('learnMore')"
          >
            Learn more
          </a>
        </div>
      </div>
    </div>
    <div class="coming-soon-bar">
      Coming soon • Coming soon • Coming soon • Coming soon • Coming soon • Coming soon • Coming soon • Coming soon • Coming soon • Coming soon • Coming soon • Coming soon • Coming soon • Coming soon • Coming soon • Coming soon
    </div>
    <div
      id="learnmore"
      class="learn-more"
    >
      <div ref="learnMore" class="learn-more-container">
        <p>The bold notes in the fragrance create a powerful impression, making the perfume a perfect match for the adventurous and tough character of the ON THAT ASS wearer. The perfume is created by a well-known perfume house in the South of France, so quality is guaranteed.</p>
        <p>Starting in early April, the fragrance will be available in limited editions (50 ml and 100 ml). Members pay €49 for the large and €25 for the small bottle, which has been designed in the familiar shape of boxer shorts.</p>
      </div>
    </div>
    <OImage
      class="cotton"
      alt="Product photo perfume"
      v-bind="getImagePaths('cotton', '.png')"
    />
    <footer>© ON THAT ASS 2023</footer>
  </div>
</template>

<script>
import { getImagePaths } from '@/utils/general'
import OImage from '@/components/OImage'

export default {
  name: 'EautaForMen',
  layout: 'minimal',
  components: { OImage },
  methods: {
    getImagePaths (path, extension) {
      return getImagePaths({
        path: `/images/campaign/eauta/${path}`,
        s3: true,
        extension
      })
    },
    pageScroll (refName) {
      const elem = this.$refs[refName]

      elem.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  },
  head () {
    return {
      title: 'Eau\'ta for men - ON THAT ASS',
      meta: [
        { hid: 'og:title', name: 'og:title', property: 'og:title', content: 'Eau\'ta for men - ON THAT ASS' },
        { hid: 'og:description', name: 'og:description', property: 'og:description', content: 'EAU&#8217;TA For Men, the new fragrance by ON THAT ASS. Eau de toilette with a hint of fresh boxer shorts. Available in limited edition.' },
        { hid: 'og:image', name: 'og:image', property: 'og:image', content: `${process.env.BASE_S3_PATH}/images/campaign/eauta/eauta-og.jpg` }
      ]
    }
  }
}
</script>

<style scoped lang="postcss">
/*
  1. Use a more-intuitive box-sizing model.
*/
*, *::before, *::after {
  box-sizing: border-box;
}

/*
  2. Remove default margin
*/
* {
  margin: 0;
}

/*
  3. Allow percentage-based heights in the application
*/
html, .body {
  height: 100%;
}

/*
  Typographic tweaks!
  4. Add accessible line-height
  5. Improve text rendering
*/
.body {
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
}

/*
  6. Improve media defaults
*/
img, picture, video, canvas, svg {
  display: block;
  max-width: 100%;
}

/*
  7. Remove built-in form typography styles
*/
input, button, textarea, select {
  font: inherit;
}

/*
  8. Avoid text overflows
*/
p, h1, h2, h3, h4, h5, h6 {
  overflow-wrap: break-word;
}

/*
  9. Create a root stacking context
*/
#root, #__next {
  isolation: isolate;
}/*# sourceMappingURL=reset.css.map */

html {
  scroll-behavior: smooth;
  position: relative;
}

.body {
  position: relative;
  width: 100%;
  background-color: #0e1114;
  color: #E2E2E3;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: "Open Sans", sans-serif;
  overflow-x: hidden;
  font-size: 20px;
}
.body h1 {
  font-weight: 700;
  font-size: 25px;
  line-height: 38px;
}
@media screen and (min-width: 800px) {
  .body h1 {
    font-size: 30px;
  }
}
.body p {
  font-weight: 400;
  font-size: 20px;
  line-height: 38px;
}
.body .a-button {
  color: #E2E2E3;
  text-decoration: none;
  padding: 12px 36px;
  border: 1px solid #E2E2E3;
  border-radius: 100px;
  font-size: 20px;
}
.body .a-line {
  color: #E2E2E3;
  text-decoration: none;
  border-bottom: 1px solid #E2E2E3;
  padding-bottom: 6px;
  font-size: 20px;
}
.body header {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 30px;
}
.body header .logofill {
  width: calc(100% - 40px);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
@media screen and (min-width: 800px) {
  .body header .logofill {
    width: calc(100% - 45px);
    justify-content: center;
    padding-left: 60px;
  }
}
.body header a svg.logo {
  cursor: pointer;
  width: 192px;
}
.body header a svg.basket {
  cursor: not-allowed;
  width: 40px;
}
@media screen and (min-width: 800px) {
  .body header a svg.basket {
    width: 45px;
  }
}
.body .top {
  margin: 50px 20px;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
@media screen and (min-width: 800px) {
  .body .top {
    margin: 80px 20px;
  }
}
@media screen and (min-width: 1000px) {
  .body .top {
    max-width: 1410px;
  }
}
.body .top .productshot {
  position: relative;
  width: 100%;
}
@media screen and (min-width: 800px) {
  .body .top .productshot {
    width: 50%;
  }
}
.body .top .productshot::before {
  position: absolute;
  content: "";
  display: block;
  left: 0px;
  top: -30px;
  width: 80%;
  aspect-ratio: 1/1;
  background-color: #456B8A;
  border-top-right-radius: 4px;
  z-index: 1;
}
@media screen and (min-width: 800px) {
  .body .top .productshot::before {
    border-radius: 4px;
    left: -30px;
  }
}
.body .top .productshot picture, .body .top .productshot .product {
  z-index: 2;
  position: relative;
  width: 100%;
  -o-object-fit: contain;
     object-fit: contain;
}
@media screen and (min-width: 800px) {
  .body .top .productshot picture, .body .top .productshot .product {
    max-width: 673px;
    border-radius: 4px;
  }
}
.body .top .productshot .coming-soon-circle {
  position: fixed;
  width: 100px;
  right: 20px;
  bottom: 90px;
  animation-name: cs-circle;
  animation-duration: 10s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  z-index: 4;
}
@media screen and (min-width: 800px) {
  .body .top .productshot .coming-soon-circle {
    position: absolute;
    width: 165px;
    top: 60px;
    bottom: auto;
    right: -52.5px;
  }
}
.body .top .intro {
  position: relative;
  margin: 30px 20px 0;
  width: 100%;
  text-align: center;
  z-index: 1;
}
@media screen and (min-width: 800px) {
  .body .top .intro {
    width: 50%;
    max-width: 506px;
    padding: 0 20px 0 100px;
    margin: 300px 0 0;
    text-align: left;
  }
}
.body .top .intro h1 {
  color: #456B8A;
  margin-bottom: 48px;
}
.body .top .intro p {
  margin-bottom: 16px;
}
.body .top .intro .intro-buttons {
  display: flex;
  margin-top: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media screen and (min-width: 800px) {
  .body .top .intro .intro-buttons {
    justify-content: flex-start;
  }
}
.body .top .intro .intro-buttons .a-button {
  cursor: not-allowed;
  margin-right: 18px;
}
.body .coming-soon-bar {
  display: none;
}
@media screen and (min-width: 800px) {
  .body .coming-soon-bar {
    display: block;
    transform: rotate(6deg);
    position: relative;
    width: calc(100% + 80px);
    margin: -220px 0 0 -40px;
    white-space: nowrap;
    padding: 10px;
    background-color: #456B8A;
    color: #E2E2E3;
    font-family: "Open Sans", sans-serif;
    font-weight: 700;
    text-transform: uppercase;
    font-size: 18px;
    text-align: center;
    z-index: 4;
  }
}
.body .learn-more {
  width: 100%;
  background-color: #0e1114;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
@media screen and (min-width: 800px) {
  .body .learn-more {
    padding: 150px 0 0;
    align-items: center;
  }
}
.body .learn-more::after {
  position: relative;
  content: "";
  display: block;
  height: 30px;
  width: 80%;
  aspect-ratio: 1/1;
  background-color: #456B8A;
  border-bottom-right-radius: 4px;
  z-index: 1;
}
@media screen and (min-width: 800px) {
  .body .learn-more::after {
    display: none;
  }
}
.body .learn-more-container {
  position: relative;
  width: 100%;
  padding: 80px 20px;
  background-color: #848D9B;
  color: #0e1114;
  z-index: 3;
}
@media screen and (min-width: 800px) {
  .body .learn-more-container {
    width: calc(100% - 60px);
    max-width: 1410px;
    border-radius: 4px;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
}
@media screen and (min-width: 800px) {
  .body .learn-more-container::before {
    position: absolute;
    content: "";
    display: block;
    right: -20px;
    bottom: -20px;
    height: 80%;
    width: 20px;
    background-color: #456B8A;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    z-index: 1;
  }
}
@media screen and (min-width: 800px) {
  .body .learn-more-container::after {
    position: absolute;
    content: "";
    display: block;
    right: -20px;
    bottom: -20px;
    height: 20px;
    width: 40%;
    max-width: 400px;
    background-color: #456B8A;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
    z-index: 1;
  }
}
.body .learn-more-container p {
  width: 100%;
  text-align: center;
  z-index: 3;
  margin-bottom: 16px;
}
@media screen and (min-width: 800px) {
  .body .learn-more-container p {
    max-width: 440px;
    text-align: left;
    margin-bottom: 0;
  }
}
@media screen and (min-width: 800px) {
  .body .learn-more-container p:first-child {
    margin-right: 40px;
  }
}
@media screen and (min-width: 800px) {
  .body .learn-more-container p:last-child {
    margin-left: 40px;
  }
}
.body .cotton {
  position: relative;
  margin: -130px 0 0;
  width: 100%;
  z-index: 3;
  display: flex;
  flex-direction: row-reverse;

  >>> img {
    padding-left: 30px;
    max-width: 100%;
  }
}
.body .cotton img {
  width: 70%;
  -o-object-fit: contain;
     object-fit: contain;
  z-index: 3;
}
@media screen and (min-width: 800px) {
  .body .cotton img {
    width: 100%;
    padding-left: 0;
    max-width: 478px;
    margin: -220px 0 0;
  }
}
@media screen and (min-width: 800px) {
  .body .cotton {
    width: 100%;
  }
}
.body footer {
  text-align: center;
  width: 100%;
  padding: 80px 20px 20px;
  color: #456B8A;
}

@keyframes cs-circle {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}/*# sourceMappingURL=style.css.map */
</style>
